import {NormDataPoint} from './norm-data-manager';
import {CropPhaseLike, vegetationPeriodEndDay} from './crop-vegetation-phase.util';

/**
 * When plantingDate anchors the norm axis and vegetation is over,
 * clamp the reference day offset to the last stage (both chart-label and planting-only paths).
 */
export function clampNormDayOffsetForPlanting(
  dayOffset: number,
  vegetationPhases: CropPhaseLike[],
): number {
  const endDay = vegetationPeriodEndDay(vegetationPhases);
  if (endDay != null && dayOffset > endDay) {
    return endDay;
  }
  return dayOffset;
}

/** Last norm segment values (for flat extension after vegetation end). */
export function lastNormSegmentValues(normData: NormDataPoint[]): {
  indexValue: number;
  indexMin: number;
  indexMax: number;
} | null {
  if (!normData.length) {
    return null;
  }
  const sorted = [...normData].sort((a, b) => a.dayStart - b.dayStart);
  const last = sorted[sorted.length - 1];
  return {
    indexValue: last.indexValue,
    indexMin: last.indexMin,
    indexMax: last.indexMax,
  };
}
